var React = require('react');

function Gototop2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Grupo_910","data-name":"Grupo 910","transform":"translate(-1187 -495)"},[React.createElement("g",{"id":"Elipse_61","data-name":"Elipse 61","transform":"translate(1187 495)","fill":"#fbd872","stroke":"#fbd872","strokeWidth":"1","key":0},[React.createElement("circle",{"cx":"24","cy":"24","r":"24","stroke":"none","key":0}),React.createElement("circle",{"cx":"24","cy":"24","r":"23.5","fill":"none","key":1})]),React.createElement("path",{"id":"Trazado_349","data-name":"Trazado 349","d":"M7930.787,1108l5.589-5.589,5.588,5.589","transform":"translate(-6725 -588)","fill":"none","stroke":"#1d1f2a","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

Gototop2.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Gototop2;

Gototop2.default = Gototop2;
